// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleTag_container_1T2pK"};